import { createContext, useContext, useEffect } from 'react';

/// Set by the frame, called by the page. A page whose name is not in the menu - one film, one
/// plugin - is the only one that knows what the bar above it should say.
export const PageTitleContext = createContext<(title: string | undefined) => void>(() => {});

/// Names the current screen in the bar above it, for as long as the screen is open. Pages that
/// have a place in the menu need none of this: the bar says which section they are in.
export function usePageTitle(title: string | undefined): void {
  const announce = useContext(PageTitleContext);

  useEffect(() => {
    announce(title);

    // The next screen may have nothing to say, and would otherwise inherit this one's name.
    return () => announce(undefined);
  }, [announce, title]);
}
